module.exports = __webpack_public_path__ + "media/images/icon_search_btn-0ea82356c5a45775b8e3a4cc72a876ab.png";